import numeral from "numeral";

function formatNumber(number) {
  const format = numeral(number).format("0,0");
  return format;
}

export default formatNumber;
